import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const SuccessRes = ({ lang, res, onHide, dataTranslate }) => {
  const data = dataTranslate.popups.add_shipping.res_message.update;
  return (
    <>
      <Modal.Header className="d-flex align-items-center justify-content-center ">
        {/* <span className="h1">{res.message}</span> */}
      </Modal.Header>

      <Modal.Body className="m-5">
        <div
          className="d-flex flex-column align-items-center gap-3 "
          dir={lang === "AR" ? "rtl" : ""}
        >

          <div className="d-flex flex-column d-flex flex-column align-items-center gap-1">
            <h1>{data.shipping_id}</h1>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        className="w-100 d-flex flex-row align-items-center"
        dir="ltr"
      >
        <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
          <Button onClick={onHide} style={{ backgroundColor: "#e65857" }}>
            {dataTranslate.popups.exports_tab.records.close}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default SuccessRes;
